import { render, staticRenderFns } from "./KennelList.vue?vue&type=template&id=66c0458c"
import script from "./KennelList.vue?vue&type=script&lang=ts"
export * from "./KennelList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports